import React from 'react';
import styled, { css } from 'styled-components';
import { Box, ProgressBar, Text } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { colors } from '@99designs/emu/settings';
import { ReactComponent as ScooterDude } from '../../../../images/scooter-dude.svg';
import { toRightGradientVibrantBlue } from '../../../../utils/customColors';

export interface ProgressDisplayProps {
    currentStepIndex: number;
    totalSteps: number;
}

const ProgressBarWrapper = styled.div`
    position: relative;
    ${mediaQuery.only('small')} {
        display: none;
    }
`;

const ProgressImageInlineSVG = styled.div<{
    progress: number;
}>`
    transition: 0.3s ease-out;
    ${({ progress }) => css`
        left: ${progress > 0 ? `calc(${progress}% - 30px)` : `-10px`};
    `}
    position: absolute;
    z-index: 2;
    top: -25px;
    width: 52px;
`;

const MobileProgressIndicator = styled(Text)`
    display: none;

    ${mediaQuery.only('small')} {
        display: inline;
    }
`;

const CurrentStep = styled.span`
    color: ${colors.grey800};
`;

export function ProgressDisplay({ currentStepIndex, totalSteps }: ProgressDisplayProps) {
    const progress = (currentStepIndex / (totalSteps - 1)) * 100;

    return (
        <Box marginX={['1bu', '2bu']} flexGrow={1}>
            <MobileProgressIndicator
                as="p"
                color="grey600"
                weight="bold"
                size="size4"
                data-testid="mobile-progress-indicator"
            >
                <CurrentStep>{currentStepIndex + 1}</CurrentStep> / {totalSteps}
            </MobileProgressIndicator>
            <ProgressBarWrapper>
                <ProgressImageInlineSVG progress={progress}>
                    <ScooterDude />
                </ProgressImageInlineSVG>
                {/* eslint-disable-next-line @nrwl/nx/workspace/ui-progressbar-require-a11y-name */}
                <ProgressBar
                    progress={progress}
                    background={colors.grey300}
                    color={toRightGradientVibrantBlue}
                    aria-label={__('Progress bar')}
                />
            </ProgressBarWrapper>
        </Box>
    );
}
